var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgStudent = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 284,
    height: 284,
    viewBox: "0 0 284 284",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M225.9 93.6L153.5 53.2C146.4 48.3 137 48.3 129.9 53.2L57.5 93.6C49.1 99.7 47.2 111.4 53.3 119.8C54.5 121.4 55.9 122.8 57.5 124L58.2 124.5L82.2 138.1V201C82.2 211.3 97.1 233.9 141.5 233.9C185.9 233.9 200.8 211.3 200.8 201V138.1L220.6 127.1V201C220.6 204.6 223.5 207.6 227.2 207.6C230.8 207.6 233.8 204.7 233.8 201V108.8C233.7 102.8 230.8 97.2 225.9 93.6ZM187.6 201C187.6 203.6 178.3 220.8 141.5 220.8C104.7 220.8 95.5 203.6 95.5 201V145.4L129.7 164.4C136.8 169.3 146.3 169.3 153.4 164.4L187.6 145.4V201ZM218.4 113.2L146 153.5C143.4 155.3 139.9 155.3 137.3 153.5L64.9 113.2C62.5 111.3 62 107.8 63.9 105.3C64.2 104.9 64.5 104.6 64.9 104.3C64.9 104.3 137.3 64.2 137.3 64C139.9 62.1 143.5 62.1 146.1 64L218.5 104.3C220.9 106.2 221.4 109.7 219.5 112.2C219.2 112.6 218.9 112.9 218.5 113.2H218.4Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStudent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/student.d6346f4d.svg";
export { ForwardRef as ReactComponent };